// @flow

import API from "../api/";
import ActionTypes from "../constants/ActionTypes";

const addSubscriberRequest = (): any => ({
    type: ActionTypes.ADD_SUBSCRIBER_REQUEST,
});

const addSubscriberSuccess = (): any => ({
    type: ActionTypes.ADD_SUBSCRIBER_SUCCESS,
});

const addSubscriberFail = (error: any): any => ({
    type: ActionTypes.ADD_SUBSCRIBER_FAIL,
    error,
});

export const addSubscriber =
    (name: string, email: string): any =>
    (dispatch: any): Promise<any> => {
        dispatch(addSubscriberRequest());
        return API.addSubscriber(name, email)
            .then((res: any): any => {
                dispatch(addSubscriberSuccess());
                return true;
            })
            .catch((error: any): any => {
                dispatch(addSubscriberFail(error));
                return false;
            });
    };
